import { Contents } from "./../../components/Contents/Contents";
import { DataContext } from "./../../context/DataContext";
import { Footer } from "./../../components/Footer/Footer";
import { Link } from "./../../components/Link/link";
import { useParams } from "react-router-dom";
import { useResetScroll } from "./../../hooks/useResetScroll";
import { useTranslation } from "react-i18next";
import { Video } from "./../../components/Video/Video";
import React from "react";

import "./project.scss";

export const Project = () => {
	const { t } = useTranslation();
	const { slug } = useParams();
	const projects = React.useContext(DataContext).projects;
	const project = projects && projects.find((project) => project.slug === slug);
	useResetScroll();

	return (
		<React.Fragment>
			<div className={`project`}>
				{project && (
					<div className={`project-intro`}>
						{project.acf.cover.visibility && (
							<div className={`project-intro-cover`}>
								{project.acf.cover.video.file ? (
									<Video {...project.acf.cover.video} />
								) : (
									<div className={`project-intro-cover-wrapper`}>
										<img
											src={project.acf.cover.immagine.sizes.large}
											alt={project.acf.cover.immagine.description}
										/>
									</div>
								)}
							</div>
						)}
						{
							<h1
								className={[`_big`, `centered`, `project-intro-caption`].join(` `)}
								dangerouslySetInnerHTML={{
									__html: project.acf.info.title || project.title.rendered,
								}}
							/>
						}
					</div>
				)}
				{project && project.acf.content && <Contents contents={project.acf.content} />}
				{project && project.acf.related && (
					<div className={`project-related`}>
						<p className={`_base centered`}>{t("related_projects")}</p>
						<div className={`project-related-row`}>
							{project &&
								project.acf.related.map((item, index) => {
									let related = projects.find((related) => related.id === item.project);
									return (
										related && (
											<Link
												key={index}
												to={`/lavori/${related.slug}`}
												className={`project-related-row-item`}>
												<div className={`project-related-row-item-cover`}>
													<img
														src={
															related.acf.cover.immagine && related.acf.cover.immagine.sizes.large
														}
														alt={related.acf.cover.immagine.description}
													/>
												</div>
												<div className={`project-related-row-item-caption`}>
													<p
														className={`_base centered`}
														dangerouslySetInnerHTML={{
															__html: related.title.rendered,
														}}
													/>
												</div>
											</Link>
										)
									);
								})}
						</div>
					</div>
				)}
			</div>
			<Footer />
		</React.Fragment>
	);
};
